import { render, staticRenderFns } from "./ReleasePage.vue?vue&type=template&id=3f8f5ffc&"
import script from "./ReleasePage.vue?vue&type=script&lang=js&"
export * from "./ReleasePage.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePage.vue?vue&type=style&index=0&id=3f8f5ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports